<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input size="medium" v-model="searchForm.userId" placeholder="请输入用户ID"  @keyup.enter.native="getTableList"></el-input>
      <el-input size="medium" v-model="searchForm.rid" placeholder="请输入RID"  @keyup.enter.native="getTableList"></el-input>
      <el-input size="medium" v-model="searchForm.orderCode" placeholder="请输入订单编号"  @keyup.enter.native="getTableList"></el-input>
      <el-input size="medium" v-model="searchForm.nodeNumber" placeholder="请输入节点编号"  @keyup.enter.native="getTableList"></el-input>
      <el-input size="medium" v-model="searchForm.productId" placeholder="请输入产品编号"  @keyup.enter.native="getTableList"></el-input>
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <div style="margin-top:10px">
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
        <a :href="url+'/web/agent/salesStatisticsDetail/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime+'&&userId='+searchForm.userId+'&&rid='+searchForm.rid+'&&orderCode='+searchForm.orderCode+'&&nodeNumber='+searchForm.nodeNumber+'&&productId='+searchForm.productId" style="margin-left:20px">
          <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
        </a>
      </div>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <!-- <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="createTime"
      width="160"
      label="创建时间">
    </el-table-column>
    <el-table-column
      prop="userId"
      label="用户ID">
    </el-table-column>
    <el-table-column
      prop="orderCode"
      width="140"
      label="订单ID">
    </el-table-column>
    <el-table-column
      prop="productId"
      label="产品编号">
    </el-table-column>
    <el-table-column
      prop="productType"
      label="产品类型">
      <template slot-scope="scope">
        <span>{{scope.row.productType==1?'封装':scope.row.productType==2?'销售':scope.row.productType==4?'联合存储':'预售'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="power"
      width="130"
      label="订单存储数(TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.power,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="priceUsdt"
      width="130"
      label="订单原价(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.priceUsdt,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="pledge"
      width="120"
      label="订单质押(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.pledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="lineRelease"
      width="120"
      label="订单Gas(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.gas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="paidUsdt"
      width="130"
      label="实收金额(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.paidUsdt,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="paidFil"
      width="120"
      label="实收金额(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.paidFil,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="paidCny"
      width="120"
      label="实收金额(CNY)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.paidCny,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="discount"
      width="130"
      label="优惠折扣(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.discount,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozen"
      width="160"
      label="实收硬件成本(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.paidCost,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="filUsdt"
      width="120"
      label="FIL/USDT汇率">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.filUsdt,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="usdtCny"
      width="130"
      label="USDT/CNY汇率">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.usdtCny,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="nodeNumber"
      width="90"
      label="挂靠节点">
    </el-table-column>
    <el-table-column
      prop="earningTime"
      width="110"
      label="挖矿开始时间">
    </el-table-column>
    <el-table-column
      prop="trus"
      label="托管费">
    </el-table-column>
    <el-table-column
      prop="rid"
      label="RID">
    </el-table-column>
    <el-table-column
      prop="channelName"
      label="归属渠道">
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime: '',
        endTime: '',
        userId: '',
        rid: '',
        orderCode: '',
        nodeNumber: '',
        productId: ''
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.salesStatisticsDetail({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
